import { Route, Routes } from "react-router-dom";
import Homepage from "./Pages/Homepage";

const routes = [{ path: "/", element: <Homepage /> }];

const App = () => {
  return (
    <Routes>
      {routes.map((route, idx) => (
        <Route key={idx} path={route.path} element={route.element} />
      ))}
    </Routes>
  );
};

export default App;
